import type { ReactElement } from "react";

import { TopHeaderMenues } from "./TopHeaderMenues";
import { SocialMedia } from "./TopSocialMedia";

export type TopHeaderProps = {
  testId?: string;
};

export function TopHeader({
  testId = "topheader",
}: TopHeaderProps): ReactElement {
  return (
    <div className="w-full bg-gray-500 hidden lg:block">
      <div className="lg:max-w-lg xl:max-w-xl w-full mx-auto px-sm h-xxm">
        <div className="inline-block mt-1">
          <SocialMedia testId={testId} />
        </div>
        <div className="float-right px-sm inline-flex font-primary">
          <TopHeaderMenues />
        </div>
      </div>
    </div>
  );
}
